import { EnvService } from "../../app/env.service";

export const EnvServiceFactory = () => {
  return new EnvService();
};

export const EnvServiceProvider = {
  provide: EnvService,
  useFactory: EnvServiceFactory,
  deps: [],
};
